import React from "react";
// State
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
// Styles
import styled from "styled-components";
// Components
import { Element } from "react-scroll";
import { Button, Col, Container, Row } from "react-bootstrap";
import Title from "./Title";
// Config
import { skillData, resume } from "../config";

const GlassCard = styled.figure`
  position: relative;
  margin: 0;
  padding: 1.5rem 1rem;
  border-radius: 16px;
  cursor: default;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
              box-shadow 0.4s cubic-bezier(0.22, 1, 0.36, 1),
              background 0.3s ease;

  /* Frosted glass base */
  background: ${({ theme }) =>
    theme.name === "light"
      ? "rgba(255, 255, 255, 0.45)"
      : "rgba(255, 255, 255, 0.06)"};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid ${({ theme }) =>
    theme.name === "light"
      ? "rgba(255, 255, 255, 0.7)"
      : "rgba(255, 255, 255, 0.1)"};

  /* Icon styling */
  .display-4 {
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  figcaption {
    margin-top: 0.75rem;
    font-size: 0.85rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    color: ${({ theme }) =>
      theme.name === "light" ? "#555" : "#bbb"};
    transition: color 0.3s ease;
  }

  &:hover {
    transform: scale(1.08);
    background: ${({ theme }) =>
      theme.name === "light"
        ? "rgba(255, 255, 255, 0.75)"
        : "rgba(255, 255, 255, 0.12)"};
    box-shadow:
      0 8px 32px ${({ theme }) =>
        theme.name === "light"
          ? "rgba(0, 0, 0, 0.08)"
          : "rgba(0, 0, 0, 0.3)"},
      inset 0 0 0 1px ${({ theme }) =>
        theme.name === "light"
          ? "rgba(255, 255, 255, 0.9)"
          : "rgba(255, 255, 255, 0.15)"};

    .display-4 {
      transform: scale(1.1);
    }

    figcaption {
      color: ${({ theme }) =>
        theme.name === "light" ? "#222" : "#f0f0f0"};
    }
  }

  &:active {
    transform: scale(1.03);
    transition-duration: 0.15s;
  }
`;

// #region component
const Skills = () => {
  const theme = useSelector(selectMode);

  return (
    <Element name={"Tech Skills"} id="skills">
      <section className="section">
        <Container className="text-center">
          <Container className="d-flex justify-content-center">
            <Title size={"h2"} text={"Tech Skills"} />
          </Container>
          <Row className="mt-3 align-items-center">
            {skillData.map((skills) => {
              return (
                <Col xs={4} key={skills.id} className="my-md-5">
                  <GlassCard>
                    {skills.skill}
                    <figcaption>{skills.name}</figcaption>
                  </GlassCard>
                </Col>
              );
            })}
          </Row>
          {resume && (
            <a href={resume}>
              <Button
                size="lg"
                variant={theme === "light" ? "outline-dark" : "outline-light"}
                className="mt-5"
              >
                R&eacute;sum&eacute;
              </Button>
            </a>
          )}
        </Container>
      </section>
    </Element>
  );
};
// #endregion

export default Skills;
